export const ADMIN_UI_PATH = 'adminUIPath';
export const ADMIN_UI_CURRENT_CONTEXT = 'adminUICurrentContext';
